// extracted by mini-css-extract-plugin
module.exports = {"standardTable":"StandardTable_standardTable__24omt","tableAlert":"StandardTable_tableAlert__ivovH"};